import { memo, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Button,
  Grid,
  Typography,
  FormGroup,
  FormControl,
  FormControlLabel,
  FormLabel,
  RadioGroup,
  Radio
} from '@mui/material';
import { CustomCheckBox, CustomTextField } from 'components';
import * as CommonActions from 'app/redux/actions';
import { medium, standard } from 'views/common/redux/actions';
import { getMediums, getStandards } from 'views/common/redux/selectors';

function EnquiryForm(props) {
  const dispatch = useDispatch();
  const phoneRegex = /[^0-9]/gi;
  const mediums = useSelector(getMediums);
  const standards = useSelector(getStandards);
  const [name, setName] = useState('');
  const [schoolName, setSchoolName] = useState('');
  const [city, setCity] = useState('');
  const [email, setEmail] = useState('');
  const [mobile, setMobile] = useState('');
  const [isValidName, setIsValidName] = useState(true);
  const [isValidSchool, setIsValidSchool] = useState(true);
  const [isValidCity, setIsValidCity] = useState(true);
  const [isValidEmail, setIsValidEmail] = useState(true);
  const [isValidPhone, setIsValidPhone] = useState(true);
  const [nameHelperText, setNameHelperText] = useState('');
  const [schoolHelperText, setSchoolHelperText] = useState('');
  const [cityHelperText, setCityHelperText] = useState('');
  const [emailHelperText, setEmailHelperText] = useState('');
  const [phoneHelperText, setPhoneHelperText] = useState('');
  const [examInterest, setExamInterest] = useState([]);
  const [selectedMedium, setSelectedMedium] = useState(1);
  const [selectedStandard, setSelectedStandard] = useState(0);
  const [selectedPreference, setSelectedPreference] = useState(0);
  const examPreference = [
    { name: 'Online', id: 1 },
    { name: 'Offline at School', id: 2 },
    { name: 'Study center', id: 3 }
  ];
  const examLists = [
    { name: 'CA-Foundation', id: 1 },
    { name: 'IIT-JEE', id: 2 },
    { name: 'NEET', id: 3 },
    { name: 'OLYMPIADS', id: 4 },
    { name: 'NTSE', id: 5 }
  ];

  useEffect(() => {
    dispatch(medium.get());
    dispatch(standard.get());
  }, []);

  const handleNameOnBlur = (e) => {
    if (e.target.value.length < 1) {
      setIsValidName(false);
      setNameHelperText('Enter valid name');
    }
  };

  const handleNameOnFocus = () => {
    setIsValidName(true);
  };

  const handleSchoolOnBlur = (e) => {
    if (e.target.value.length < 1) {
      setIsValidSchool(false);
      setSchoolHelperText('Enter valid school name');
    }
  };

  const handleSchoolOnFocus = () => {
    setIsValidSchool(true);
  };

  const handleCityOnBlur = (e) => {
    if (e.target.value.length < 1) {
      setIsValidCity(false);
      setCityHelperText('Enter valid city');
    }
  };

  const handleCityOnFocus = () => {
    setIsValidCity(true);
  };

  const handleEmailOnBlur = (e) => {
    const rEx = /\S+@\S+\.\S+/;
    const isValidEmail = rEx.test(e.target.value);
    if (!isValidEmail) {
      setIsValidEmail(isValidEmail);
      setEmailHelperText('Enter valid email address');
    } else {
      setIsValidEmail(true);
    }
  };

  const handleEmailOnFocus = () => {
    setIsValidEmail(true);
  };

  const handleMobileOnBlur = (e) => {
    const isValidMobile = e.target.value.length === 10;
    if (!isValidMobile) {
      setIsValidPhone(isValidMobile);
      setPhoneHelperText('Enter Valid 10 digit Mobile number');
    } else {
      setIsValidPhone(true);
    }
  };

  const handleMobileOnFocus = () => {
    setIsValidPhone(true);
  };

  const onChangeEvent = (selectedId, isSelected) => {
    if (isSelected) {
      setExamInterest((prevStae) => [...prevStae, selectedId]);
    } else {
      setExamInterest((prevState) => prevState.filter((id) => id !== selectedId));
    }
  };

  const submitEnable = () => selectedMedium > 0 && selectedStandard > 0 && examInterest.length > 0;

  const onCancel = () => {
    props.onCancel();
  };

  const onSubmit = () => {
    if (selectedMedium !== -1 && selectedStandard !== -1 && examInterest.length > 0) {
      props.onSubmit();
      dispatch(CommonActions.startLoading());
      window.Email.send({
        Host: 'smtp.office365.com',
        Username: 'info@naviralive.com',
        Password: 'Navira@123',
        To: 'support@naviralive.com',
        From: 'info@naviralive.com',
        Subject: `${name}/${mobile}`,
        Body: `<html>
        <h2>${name} Details</h2>
        <div style='padding:10px 20px;font-size:16px;'>
          <table style='margin:auto;border:5px solid #aaa;'>
            <tr>
              <td style='padding:10px 20px;color:#333;font-weight:600;text-transform:capitalize;'>Name</td>
              <td style='padding:10px 20px;font-weight:600;'>: ${name}</td>
            </tr>
            <tr>
              <td style='padding:10px 20px;color:#333;font-weight:600;text-transform:capitalize;'>School Name</td>
              <td style='padding:10px 20px;font-weight:600;'>: ${schoolName}</td>
            </tr>
            <tr>
              <td style='padding:10px 20px;color:#333;font-weight:600;text-transform:capitalize;'>City</td>
              <td style='padding:10px 20px;font-weight:600;'>: ${city}</td>
            </tr>
            <tr>
              <td style='padding:10px 20px;color:#333;font-weight:600;text-transform:capitalize;'>Mobile</td>
              <td style='padding:10px 20px;font-weight:600;'>: ${mobile}</td>
            </tr>
            <tr>
              <td style='padding:10px 20px;color:#333;font-weight:600;text-transform:capitalize;'>Email</td>
              <td style='padding:10px 20px;font-weight:600;'>: ${email}</td>
            </tr>
            <tr>
              <td style='padding:10px 20px;color:#333;font-weight:600;text-transform:capitalize;'>Exam Interested</td>
              <td style='padding:10px 20px;font-weight:600;'>: ${
                examLists?.filter((exam) => exam.id === examInterest[0])[0]?.name
              }</td>
            </tr>
            <tr>
              <td style='padding:10px 20px;color:#333;font-weight:600;text-transform:capitalize;'>Medium</td>
              <td style='padding:10px 20px;font-weight:600;'>: ${
                mediums?.filter((medium) => medium.id === selectedMedium)[0]?.name
              }</td>
            </tr>
            <tr>
              <td style='padding:10px 20px;color:#333;font-weight:600;text-transform:capitalize;'>Standard</td>
              <td style='padding:10px 20px;font-weight:600;'>: ${
                standards?.filter((standard) => standard.id === selectedStandard)[0]?.name
              }</td>
            </tr>
            <tr>
              <td style='padding:10px 20px;color:#333;font-weight:600;text-transform:capitalize;'>Exam Preference</td>
              <td style='padding:10px 20px;font-weight:600;'>: ${
                examPreference?.filter((pref) => pref.id === selectedPreference)[0]?.name
              }</td>
            </tr>
          </table>
        </div>
      </html>`
      }).then(() => dispatch(CommonActions.stopLoading()));
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="subtitle2">Submit Form</Typography>
      </Grid>
      <Grid item xs={12} sm={6}>
        <CustomTextField
          label="Name"
          required
          error={!isValidName}
          helperText={!isValidName && nameHelperText}
          variant="outlined"
          placeholder="Name"
          fullWidth
          value={name}
          onChange={(e) => setName(e.target.value)}
          onBlur={handleNameOnBlur}
          onFocus={handleNameOnFocus}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <CustomTextField
          label="School Name"
          required
          error={!isValidSchool}
          helperText={!isValidSchool && schoolHelperText}
          variant="outlined"
          placeholder="School Name"
          fullWidth
          value={schoolName}
          onChange={(e) => setSchoolName(e.target.value)}
          onBlur={handleSchoolOnBlur}
          onFocus={handleSchoolOnFocus}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <CustomTextField
          label="City"
          required
          error={!isValidCity}
          helperText={!isValidCity && cityHelperText}
          variant="outlined"
          placeholder="City"
          fullWidth
          value={city}
          onChange={(e) => setCity(e.target.value)}
          onBlur={handleCityOnBlur}
          onFocus={handleCityOnFocus}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <CustomTextField
          label="Mobile"
          required
          error={!isValidPhone}
          helperText={!isValidPhone && phoneHelperText}
          variant="outlined"
          placeholder="Mobile"
          fullWidth
          inputProps={{ pattern: /[^0-9]/gi }}
          value={mobile}
          onChange={(e) => {
            e.target.value = e.target.value.replace(phoneRegex, '');
            setMobile(e.target.value);
          }}
          onBlur={handleMobileOnBlur}
          onFocus={handleMobileOnFocus}
        />
      </Grid>
      <Grid item xs={10} sm={10}>
        <CustomTextField
          label="Email"
          required
          error={!isValidEmail}
          helperText={!isValidEmail && emailHelperText}
          variant="outlined"
          placeholder="Email Id"
          fullWidth
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          onBlur={handleEmailOnBlur}
          onFocus={handleEmailOnFocus}
        />
      </Grid>
      <Grid item xs={12}>
        <FormControl component="fieldset">
          <FormLabel component="legend">Select your interested Exam (* Required)</FormLabel>
          <FormGroup row>
            {examLists?.map((examlistItem) => (
              <CustomCheckBox
                id={examlistItem.id}
                key={examlistItem.id}
                name={examlistItem.name}
                title={examlistItem.name}
                handleChecked={onChangeEvent}
              />
            ))}
          </FormGroup>
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <FormControl component="fieldset">
          <FormLabel component="legend">Select your medium (* Required)</FormLabel>
          <RadioGroup
            aria-label="medium"
            name="medium"
            value={selectedMedium}
            onChange={(e) => setSelectedMedium(+e.target.value)}
            row
          >
            {mediums?.map((medium) => (
              <FormControlLabel
                key={medium.id}
                value={medium.id}
                control={<Radio color="primary" />}
                label={medium.name}
              />
            ))}
          </RadioGroup>
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <FormControl component="fieldset">
          <FormLabel component="legend">Select your standard (* Required)</FormLabel>
          <RadioGroup
            aria-label="standard"
            name="standard"
            value={selectedStandard}
            onChange={(e) => setSelectedStandard(+e.target.value)}
            row
          >
            {standards?.map((standard) => (
              <FormControlLabel
                key={standard.id}
                value={standard.id}
                control={<Radio color="primary" />}
                label={`Class ${standard.name}`}
              />
            ))}
          </RadioGroup>
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <FormControl component="fieldset">
          <FormLabel component="legend">Select your exam preference(* Required)</FormLabel>
          <RadioGroup
            aria-label="preference"
            name="preference"
            value={selectedPreference}
            onChange={(e) => setSelectedPreference(+e.target.value)}
            row
          >
            {examPreference?.map((preference) => (
              <FormControlLabel
                key={preference.id}
                value={preference.id}
                control={<Radio color="primary" />}
                label={preference.name}
              />
            ))}
          </RadioGroup>
        </FormControl>
      </Grid>
      <Grid item container justifyContent="center" spacing={2}>
        <Grid item>
          <Button variant="contained" color="primary" onClick={onCancel} disabled={!submitEnable}>
            Cancel
          </Button>
        </Grid>
        <Grid item>
          <Button variant="contained" color="primary" onClick={onSubmit} disabled={!submitEnable}>
            Submit
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default memo(EnquiryForm);
